/**
 * Free gift with purchase, Dawn version of the Sip-Sip Hooray feature.
 * Keeps exactly one $0 gift line (hidden property _free_gift) in the cart while the paid
 * subtotal reaches the minimum, and removes it when the cart stops qualifying, when the
 * gift product changes, after the last day, or when the feature is switched off.
 * Add-on lines (proof, gift wrap, gift note) count toward the subtotal like any paid line.
 */
(function () {
  var el = document.getElementById('m4y-free-gift-config');
  var config = el ? JSON.parse(el.textContent || '{}') : {};
  var GIFT = '_free_gift';
  var busy = false;
  var today = new Date().toLocaleDateString('en-CA');
  var expired = /^\d{4}-\d{2}-\d{2}$/.test(config.lastDay || '') && today > config.lastDay;
  function isGift(i) { return i.properties && i.properties[GIFT]; }
  function json(url, body) {
    return fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function redraw() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift' });
    fetch(window.location.pathname + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var b = document.getElementById('cart-icon-bubble');
      if (b && s['cart-icon-bubble']) b.innerHTML = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
    }).catch(function () {});
  }
  function reconcile() {
    if (busy) return; busy = true;
    json(window.routes.cart_url + '.js').then(function (cart) {
      var gifts = cart.items.filter(isGift);
      var paid = cart.items.filter(function (i) { return !isGift(i); });
      var subtotal = paid.reduce(function (s, i) { return s + i.final_line_price; }, 0);
      var qualifies = config.enabled && !expired && config.variantId && paid.length > 0 && subtotal >= config.minimum;
      for (var k = 0; k < gifts.length; k++) {
        var keep = qualifies && gifts[k].variant_id === config.variantId;
        if (!keep || gifts[k].quantity !== 1) return json(window.routes.cart_change_url + '.js', { id: gifts[k].key, quantity: keep ? 1 : 0 }).then(function () { busy = false; redraw(); setTimeout(reconcile, 50); });
      }
      if (qualifies && !gifts.length) {
        return json(window.routes.cart_add_url + '.js', { items: [{ id: config.variantId, quantity: 1, properties: { _free_gift: 'yes' } }] }).then(redraw);
      }
    }).catch(function (e) { console.warn('[free-gift]', e); }).finally(function () { busy = false; });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) { if (event && event.source === 'free-gift') return; setTimeout(reconcile, 60); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile); else reconcile();
})();
